import { FC } from 'react';
import classNames from 'classnames';
import { AdminCartRecipient } from 'store/shoppingCart/types';
import { AccordionButton } from 'views/Pages/Accordions/AccordionButton';
import { DonationAmountsForm } from 'views/Pages/Forms/DonationAmountsForm';
import { CheckoutPageDesignSection } from './CheckoutPageDesignSection';
import { ShoppingCartSettingsSection } from './ShoppingCartSettingsSection';
import {
  CHECKOUT_PAGE_DESIGN_SECTION_INDEX,
  DONATION_OPTIONS_SECTION_INDEX,
  SETTINGS_SECTION_INDEX,
  SHOPPING_CART_SECTIONS,
} from './constants';

type Props = {
  index: number;
  itemVisible: number;
  cartRecipients?: AdminCartRecipient[];
  isEditing: boolean;
  isSubmitting: boolean;
  onNext: () => void;
};

export const ShoppingCartAccordion: FC<Props> = ({
  index,
  itemVisible,
  cartRecipients,
  isEditing,
  isSubmitting,
  onNext,
}) => (
  <div
    className={classNames('accordion-content', {
      'accordion-content--visible': itemVisible === index,
      'accordion-content--hidden': itemVisible !== index,
    })}
  >
    <div className="card">
      <div className="card-body card-body-page-detail">
        {index === SETTINGS_SECTION_INDEX && <ShoppingCartSettingsSection />}
        {index === CHECKOUT_PAGE_DESIGN_SECTION_INDEX && (
          <CheckoutPageDesignSection cartRecipients={cartRecipients} />
        )}
        {index === DONATION_OPTIONS_SECTION_INDEX &&
          (isEditing ? (
            <p className="oath-bodysmall color-gray">
              Donation amounts can&apos;t be changed here. Edit them on this cart&apos;s page in the
              page editor.
            </p>
          ) : (
            <DonationAmountsForm />
          ))}
        {index < SHOPPING_CART_SECTIONS.length - 1 ? (
          <AccordionButton onClick={onNext}>Next</AccordionButton>
        ) : (
          <AccordionButton
            type="submit"
            variant="submit"
            isSubmitting={isSubmitting}
            submittingText={isEditing ? 'Saving...' : 'Activating...'}
          >
            {isEditing ? 'Save' : 'Activate'}
          </AccordionButton>
        )}
      </div>
    </div>
  </div>
);
